export class NameDisplayPreference {
  prefix: string;
  firstName: string;
  middleName: string;
  lastName: string;
  suffix: string;
  customFirstName: string;
  customMiddleName: string;
  customLastName: string;
  keepAsIs: boolean;

  constructor() {
    this.prefix = '';
    this.firstName = '';
    this.middleName = '';
    this.lastName = '';
    this.suffix = '';
    this.customFirstName = '';
    this.customMiddleName = '';
    this.customLastName = '';
    this.keepAsIs = false;
  }
}
